import React, { useState, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import { config } from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import SchoolCombo from '../combos/SchoolCombo';
import { RadioButton } from "primereact/radiobutton";


export default function SchoolPaymentCheque(props) {
  const [redirectUrl, setRedirectUrl] = useState("");
  const [errorVisible, setErorVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editFormVisible, setEditFormVisible] = useState(false);
  const [chequeStateFormVisible, setChequeStateFormVisible] = useState(false);
  const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);


  const [currentItem, setCurrentItem] = useState(null);
  const [items, setItems] = useState([]);
  const [filterItems, setFilterItems] = useState([]);
  const LoadingRows = Array.from({ length: 5 });

  const [school, setSchool] = useState({});
  const [payDate, setPayDate] = useState(0);
  const [amount, setAmount] = useState(0);
  const [comment, setComment] = useState("");
  const [chequeSerialNo, setChequeSerialNo] = useState("");
  const [chequeDate, setChequeDate] = useState(0);
  const [chequeVajh, setChequeVajh] = useState("");
  const [chequeNationalId, setChequeNationalId] = useState("");
  const [selectedState, setSelectedState] = useState(1);


  useEffect(() => {
    setLoading(true);

    var params = { login: util.getTrustedUser(), schoolId: "", searchText: "", fromAmount: 0, toAmount: 0, fromDate: 0, toDate: 0, lastIndex: 0, pageSize: 0 };
    var url = config.Server + `/payment/school-payment/cheque/list`;
    console.log("params is>", params);
    console.log("url is>", url);
    axios
      .post(url, params)
      .then(res => {
        var response = res.data;
        if (response.state === "ok") {
          response = response.data;
          console.log("response is>", response);

          setItems(response);
          setFilterItems(response);

          setLoading(false);

        }
        else {
          setErrorMessage(response.message);
          setErorVisible(true);
          setSaving(false);
        }
      })
      .catch(error => {
        setErrorMessage(error.code + "," + error.message);
        setErorVisible(true);
        setSaving(false);
      });

  }, [])

  const addNewItem = function () {
    setSchool({});
    setPayDate(0);
    setAmount(0);
    setComment("");
    setChequeSerialNo("");
    setChequeDate(0);
    setChequeVajh("");
    setChequeNationalId("");
    setEditFormVisible(true);
    setCurrentItem({ id: "" });
  }

  const onRowEditClick = function (row) {
    setCurrentItem(row);
    setSchool(row.school);
    setPayDate(row.payDate);
    setAmount(row.amount);
    setComment(row.comment);
    setChequeSerialNo(row.chequeSerialNo);
    setChequeDate(row.chequeDate);
    setChequeVajh(row.chequeVajh);
    setChequeNationalId(row.chequeNationalId);

    setEditFormVisible(true);
  }

  const onRowSetStateClick = function (row) {
    setCurrentItem(row);
    setSelectedState(row.chequeState.id);
    setChequeStateFormVisible(true);
  }

  const checkDataEntry = function () {
    if (school == null) {
      setErrorMessage("مدرسه را انتخاب کنید");
      setErorVisible(true);
      return false;
    }
    if (school.id == null) {
      setErrorMessage("مدرسه را انتخاب کنید");
      setErorVisible(true);
      return false;
    }
    if (school.id == "") {
      setErrorMessage("مدرسه را انتخاب کنید");
      setErorVisible(true);
      return false;
    }
    if ((payDate == 0) || (payDate == "") || (payDate == null)) {
      setErrorMessage("تاریخ پرداخت را وارد کنید");
      setErorVisible(true);
      return false;
    }
    if ((amount == 0) || (amount == "") || (amount == null)) {
      setErrorMessage("مقدار را را وارد کنید");
      setErorVisible(true);
      return false;
    }
    if ((chequeDate == 0) || (chequeDate == "") || (chequeDate == null)) {
      setErrorMessage("تاریخ چک را را وارد کنید");
      setErorVisible(true);
      return false;
    }
    if (comment.trim().length == 0) {
      setErrorMessage("شرح را وارد کنید");
      setErorVisible(true);
      return false;
    }
    if (chequeSerialNo.trim().length == 0) {
      setErrorMessage("شماره سریال چک را وارد کنید");
      setErorVisible(true);
      return false;
    }
    if (chequeVajh.trim().length == 0) {
      setErrorMessage("وجه چک را وارد کنید");
      setErorVisible(true);
      return false;
    }
    if (chequeNationalId.trim().length == 0) {
      setErrorMessage("شماره ملی چک را وارد کنید");
      setErorVisible(true);
      return false;
    }
    return true;
  }
  const saveItem = function () {
    if (!checkDataEntry()) return;
    setSaving(true);
    var id = "";
    if (currentItem != null) {
      id = currentItem.id;
    }
    var params = { login: util.getTrustedUser(), id: id, schoolId: school.id, payDate: payDate, amount: amount, chequeSerialNo: chequeSerialNo, chequeDate: chequeDate, chequeVajh: chequeVajh, chequeNationalId: chequeNationalId, comment: comment };
    var url = config.Server + `/payment/school-payment/cheque/save`;
    axios
      .post(url, params)
      .then(res => {
        var response = res.data;
        if (response.state === "ok") {
          response = response.data;
          var tmp = [...items];
          if (id === "") {
            tmp.push(response);
          }
          else {
            for (var i = 0; i < tmp.length; i++) {
              if (tmp[i].id === id) {
                tmp[i] = {
                  id: id,
                  school: school,
                  payDate: payDate,
                  amount: amount,
                  chequeSerialNo: chequeSerialNo,
                  chequeDate: chequeDate,
                  chequeVajh: chequeVajh,
                  comment: comment,
                  chequeNationalId: chequeNationalId,
                  chequeState:{...tmp[i].chequeState}
                }
                setCurrentItem(tmp[i]);
                break;
              }
            }
          }
          setItems(tmp);
          setFilterItems(tmp);

          setSaving(false);
          setEditFormVisible(false);
        }
        else {
          setErrorMessage(response.message);
          setErorVisible(true);
          setSaving(false);
        }
      })
      .catch(error => {
        setErrorMessage(error.code + "," + error.message);
        setErorVisible(true);
        setSaving(false);
      });
  }
  const saveChequeState = function () {
    setSaving(true);
    var id = currentItem.id;
    var params = { login: util.getTrustedUser(), id: id, chequeState: selectedState };
    var url = config.Server + `/payment/school-payment/cheque/set-state`;
    axios
      .post(url, params)
      .then(res => {
        var response = res.data;
        if (response.state === "ok") {
          response = response.data;
          var tmp = [...items];
          for (var i = 0; i < tmp.length; i++) {
            if (tmp[i].id === id) {
              var title = "صادر شده";
              if (selectedState === 2) title = "وصول شده";
              else if (selectedState === 3) title = "برگشت شده";
                tmp[i] = {
                  id: tmp[i].id,
                  school: tmp[i].school,
                  payDate: tmp[i].payDate,
                  amount: tmp[i].amount,
                  chequeSerialNo: tmp[i].chequeSerialNo,
                  chequeDate: tmp[i].chequeDate,
                  chequeVajh: tmp[i].chequeVajh,
                  comment: tmp[i].comment,
                  chequeNationalId: tmp[i].chequeNationalId,
                  chequeState:{ id: selectedState, title: title }
                }

              setCurrentItem(tmp[i]);
              break;
            }
          }
          setItems(tmp);
          setFilterItems(tmp);

          setSaving(false);
          setChequeStateFormVisible(false);
        }
        else {
          setErrorMessage(response.message);
          setErorVisible(true);
          setSaving(false);
        }
      })
      .catch(error => {
        setErrorMessage(error.code + "," + error.message);
        setErorVisible(true);
        setSaving(false);
      });
  }
  const closeEditDialog = function () {
    setEditFormVisible(false);
  }
  const closeSetStateDialog = function () {
    setChequeStateFormVisible(false);
  }

  const onInputChange = function (e, name) {
    var val = '';
    val = (e.target && e.target.value) || '';
    if (name === "school") setSchool(val);
    else if (name === "payDate") setPayDate(val);
    else if (name === "amount") setAmount(val);
    else if (name === "comment") setComment(val);
    else if (name === "chequeSerialNo") setChequeSerialNo(val);
    else if (name === "chequeDate") setChequeDate(val);
    else if (name === "chequeVajh") setChequeVajh(val);
    else if (name === "chequeNationalId") setChequeNationalId(val);
  }
  const onComboChange = function (name, value) {
    if (name == 'school') {
      setSchool(value);
      return
    }
  }
  const editDialogFooter = function () {
    return (
      <GeneralDialogFooter onOkClick={() => { saveItem() }} onCancelClick={() => { closeEditDialog() }} saving={saving} />
    )
  }
  const setStateDialogFooter = function () {
    return (
      <GeneralDialogFooter onOkClick={() => { saveChequeState() }} onCancelClick={() => { closeSetStateDialog() }} saving={saving} />
    )
  }



  const setRowActions = function (row) {
    return (
      <React.Fragment>
        <Button icon="pi pi-pencil" rounded severity="success" size="small" style={{ margin: "0px 3px" }} onClick={() => onRowEditClick(row)} title="ویرایش" />
        <Button icon="pi pi-list-check" rounded severity="primary" size="small" style={{ margin: "0px 3px" }} onClick={() => onRowSetStateClick(row)} title="تنظیم وضعیت" />
      </React.Fragment>
    );
  }

  return (
    <>
      <div className="card">
        <div className="page-caption">لیست چک های مدارس</div>
        {
          loading ?
            <>
              <DataTable value={LoadingRows} className="p-datatable-striped">
                <Column header="کد" style={{ width: '20%' }} body={<Skeleton />}></Column>
                <Column header="عنوان" style={{ width: '80%' }} body={<Skeleton />}></Column>
              </DataTable>
            </>
            :
            <>
              <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign: "right" }}>
                <Button label="افزودن به لیست" icon="pi pi-plus" onClick={() => addNewItem()} severity="secondary" iconPos="right" />
              </div>

              <DataTable value={filterItems} selectionMode={true ? null : 'radiobutton'} scrollable tableStyle={{ minWidth: '50rem' }} size="small" stripedRows paginator rows={50} rowsPerPageOptions={[50, 100, 200, 500]}
                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                currentPageReportTemplate="{first} تا {last} از {totalRecords}"
                dataKey="id" selection={currentItem} onSelectionChange={(e) => { setCurrentItem(e.value) }}>
                <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column>
                <Column header="#" headerStyle={{ width: '3rem' }} body={(data, options) => options.rowIndex + 1} className="list-cell-text-align"></Column>
                {config.ShowListId ? <Column field="id" header={"شناسه"} sortable className="list-cell-text-align"></Column> : <></>}
                <Column field="chequeState.title" body={(row) => row.chequeState.title} header={"وضعیت چک"} sortable className="list-cell-text-align"></Column>
                <Column field="school.schoolName" body={(row) => row.school.schoolName} header={"مدرسه"} sortable className="list-cell-text-align"></Column>
                <Column field="payDate" body={(row) => util.SeperateDate(row.payDate)} header={"تاریخ پرداخت"} sortable className="list-cell-text-align"></Column>
                <Column field="amount" body={(row) => util.SeperatePrice(row.amount)} header={"مقدار"} sortable className="list-cell-text-align"></Column>
                <Column field="comment" header={"شرح"} sortable className="list-cell-text-align"></Column>
                <Column field="chequeSerialNo" header={"شماره سریال چک"} sortable className="list-cell-text-align"></Column>
                <Column field="chequeDate" body={(row) => util.SeperateDate(row.chequeDate)} header={"تاریخ چک"} sortable className="list-cell-text-align"></Column>
                <Column field="chequeVajh" body={(row) => util.SeperatePrice(row.chequeVajh)} header={"وجه چک"} sortable className="list-cell-text-align"></Column>
                <Column field="chequeNationalId" header={"شماره ملی چک"} sortable className="list-cell-text-align"></Column>
                <Column body={(row) => setRowActions(row)} exportable={false} style={{ maxWidth: '6rem' }}></Column>
              </DataTable>
            </>
        }
      </div>
      {
        editFormVisible ?
          <Dialog visible={true} style={{ width: '50rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
            header="ثبت چک مدرسه" modal className="p-fluid" footer={() => editDialogFooter()} onHide={() => closeEditDialog()}>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr><td>&nbsp;</td></tr>
                <tr>
                  <td style={{ padding: "1px" }}>
                    <SchoolCombo returnFullItem={true} includeActive={true} includeInActive={true} value={school} onChange={(val) => onComboChange('school', val)} />
                  </td>
                </tr>
                <tr><td>&nbsp;</td></tr>
                <tr>
                  <td style={{ padding: "1px" }}>
                    <FloatLabel>
                      <InputText value={payDate} onChange={(e) => { onInputChange(e, "payDate") }} id="payDate" keyfilter="int" maxLength={10} className="p-inputtext-lg" style={{ width: "100%", textAlign: "center" }} />
                      <label htmlFor="username"> تاریخ پرداخت</label>
                    </FloatLabel>
                  </td>
                </tr>
                <tr><td>&nbsp;</td></tr>
                <tr>
                  <td style={{ padding: "1px" }}>
                    <FloatLabel>
                      <InputText value={amount} onChange={(e) => { onInputChange(e, "amount") }} id="amount" keyfilter="int" maxLength={10} className="p-inputtext-lg" style={{ width: "100%", textAlign: "center" }} />
                      <label htmlFor="username">مقدار</label>
                    </FloatLabel>
                  </td>
                </tr>
                <tr><td>&nbsp;</td></tr>
                <tr>
                  <td style={{ padding: "1px" }}>
                    <FloatLabel>
                      <InputText value={chequeSerialNo} onChange={(e) => { onInputChange(e, "chequeSerialNo") }} id="chequeSerialNo" keyfilter="" maxLength={30} className="p-inputtext-lg" style={{ width: "100%", textAlign: "center" }} />
                      <label htmlFor="username">شماره سریال چک</label>
                    </FloatLabel>
                  </td>
                </tr>
                <tr><td>&nbsp;</td></tr>
                <tr>
                  <td style={{ padding: "1px" }}>
                    <FloatLabel>
                      <InputText value={chequeDate} onChange={(e) => { onInputChange(e, "chequeDate") }} id="chequeDate" keyfilter="int" maxLength={50} className="p-inputtext-lg" style={{ width: "100%", textAlign: "center" }} />
                      <label htmlFor="username">تاریخ چک</label>
                    </FloatLabel>
                  </td>
                </tr>
                <tr><td>&nbsp;</td></tr>
                <tr>
                  <td style={{ padding: "1px" }}>
                    <FloatLabel>
                      <InputText value={chequeVajh} onChange={(e) => { onInputChange(e, "chequeVajh") }} id="chequeVajh" keyfilter="" maxLength={50} className="p-inputtext-lg" style={{ width: "100%", textAlign: "center" }} />
                      <label htmlFor="username">وجه چک</label>
                    </FloatLabel>
                  </td>
                </tr>
                <tr><td>&nbsp;</td></tr>
                <tr>
                  <td style={{ padding: "1px" }}>
                    <FloatLabel>
                      <InputText value={comment} onChange={(e) => { onInputChange(e, "comment") }} id="comment" keyfilter="" maxLength={50} className="p-inputtext-lg" style={{ width: "100%", textAlign: "center" }} />
                      <label htmlFor="username">شرح</label>
                    </FloatLabel>
                  </td>
                </tr>
                <tr><td>&nbsp;</td></tr>
                <tr>
                  <td style={{ padding: "1px" }}>
                    <FloatLabel>
                      <InputText value={chequeNationalId} onChange={(e) => { onInputChange(e, "chequeNationalId") }} id="chequeNationalId" keyfilter="" maxLength={50} className="p-inputtext-lg" style={{ width: "100%", textAlign: "center" }} />
                      <label htmlFor="username">شماره ملی چک</label>
                    </FloatLabel>
                  </td>
                </tr>
                <tr><td>&nbsp;</td></tr>

              </tbody>
            </table>
          </Dialog>
          :
          <></>
      }

      {
        chequeStateFormVisible ?
          <Dialog visible={true} style={{ width: '50rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
            header="ثبت وضعیت چک مدرسه" modal className="p-fluid" footer={() => setStateDialogFooter()} onHide={() => closeSetStateDialog()}>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr><td>&nbsp;</td></tr>
                <tr>
                  <td>
                    <RadioButton inputId={"rdo1"} name="category" value={1} onChange={(e) => setSelectedState(e.value)} checked={selectedState === 1} />
                    &nbsp;&nbsp;<label htmlFor={"rdo1"} className="ml-2">صادر شده</label>
                  </td>
                </tr>
                <tr><td>&nbsp;</td></tr>
                <tr>
                  <td>
                    <RadioButton inputId={"rdo2"} name="category" value={2} onChange={(e) => setSelectedState(e.value)} checked={selectedState === 2} />
                    &nbsp;&nbsp;<label htmlFor={"rdo2"} className="ml-2">وصول شده</label>
                  </td>
                </tr>
                <tr><td>&nbsp;</td></tr>
                <tr>
                  <td>
                    <RadioButton inputId={"rdo3"} name="category" value={3} onChange={(e) => setSelectedState(e.value)} checked={selectedState === 3} />
                    &nbsp;&nbsp;<label htmlFor={"rdo3"} className="ml-2">بازگشت شده</label>
                  </td>
                </tr>
              </tbody>
            </table>
          </Dialog>
          :
          <></>
      }

      <ShowError visible={errorVisible} message={errorMessage} closeError={() => { setErorVisible(false) }} />
    </>
  );
}
